import baseFetchApi from 'ehome-utils/lib/fetchApi';
import { message, notification, Modal } from 'antd';
import { cache, localStorage } from 'utils';
import LZString from 'lz-string';
import { headersMethod } from 'utils/requestHeaderMethod';

const decompressUrlQuery = str => LZString.decompressFromEncodedURIComponent(str);

function fetchApi ({
	error,
	noPrivilege,
	data: commandObject = {},
	defaultError = true,
	ignoreNamespaceId = false,
	ignoreModulePath = false,
	service = '/api',
	isDataReport = false,
	...resetConfig
} = {}) {
	// 自动加上 namespaceId 参数
	let namespaceId = window.$$context && window.$$context.namespaceId;
	if (isDataReport) namespaceId = window.$$dashboardInfo?.namespaceId || namespaceId;
	if (!ignoreNamespaceId) commandObject = Object.assign({ namespaceId }, commandObject);

	// 统一增加参数
	const { externalParams, reportType, nodeId } = window.$$dashboardInfo || {};
	if (isDataReport && externalParams) {
		commandObject = Object.assign({ externalParams }, commandObject);
	}

	if (isDataReport && reportType === 'reportCenterDashboard') {
		const { organizationId, appId } = window.$$context || {};

		commandObject = Object.assign({
			organizationId,
			originId: appId,
			...(nodeId ? { nodeId } : {})
		 }, commandObject);
	}

	// 自动加上 _modulePath 参数
	const _modulePath = window.$$context && window.$$context._modulePath;
	if (!ignoreModulePath) commandObject = Object.assign({ _modulePath }, commandObject);
	// 在wepark环境下，需要统一加上 /zuolin/private 前缀
	if (window.envType === 'wepark') service = '/zuolin/private' + service;

	// 请求header中增加字段
	let headers = {};
	const isOA = window.env !== 'EhZuolinAdmins';
	if (isOA) {
		headers = {
			'X-Context': headersMethod.genXContext(),
		};
	}

	const dashboardToken = window.$$dashboardInfo && window.$$dashboardInfo.dashboardToken;
	if (isDataReport && dashboardToken) {
		headers = {
			token: dashboardToken,
		};
	}

	const interceptors = {
		response: function (response) {
			// Any status code that lie within the range of 2xx cause this function to trigger
			// Do something with response data

			let resData = response.data;
			if (resData.q) {
				resData = JSON.parse(decompressUrlQuery(resData.q));
				resData.errorCode = resData.err_code;
				resData.response = resData.data;
			}
			response = { ...response, data: resData };

			const errorCode = Number(resData.errorCode);
			if (errorCode === 200) {
				return response;
			}

			// 当前系统所在的环境
			const envType = window.envType || 'zuolin';
			if (errorCode === 401 && envType === 'zuolin') {
				// 在zuolin系统中，接口授权不通过时，统一跳转到登录页
				let url = window.location.origin + window.location.pathname;
				url = url.replace(/[^/]+\.html$/, 'index.html');
				url = url + '#/login';
				window.location.href = url;
			} else if (errorCode === 100055) {
				notification.warning({
					key: 'noPrivilege',
					message: '权限不足',
					description: '你暂无此功能权限，请联系管理员。'
				});
				if (noPrivilege) {
					noPrivilege(resData);
				} else {
					error && error(resData);
				}
			} else if (errorCode === 100027) {
				if (!localStorage.read('basic_info')) {
					return;
				}
				notification.warning({
					message: '',
					description: '登录信息过期，请重新登录。'
				});
				localStorage.clearAll();
				cache.clear();
				document.cookie = 'token' + '=;expires=' + (new Date(0)).toGMTString();
				let url = window.location.origin + window.location.pathname;
				url = url.replace(/[^/]+\.html$/, 'index.html');
				url = url + '#/login';
				if (window.location.href === url) {
					window.location.reload();
				} else {
					window.location.href = url;
				}
				// if (noPrivilege) {
				// 	noPrivilege(resData);
				// } else {
				// 	error && error(resData);
				// }
			} else if (errorCode === 100028) {
				if (!localStorage.read('basic_info')) {
					return;
				}
				notification.warning({
					message: '',
					description: '密码已修改，请重新登录'
				});
				localStorage.clearAll();
				cache.clear();
				document.cookie = 'token' + '=;expires=' + (new Date(0)).toGMTString();
				let url = window.location.origin + window.location.pathname;
				url = url.replace(/[^/]+\.html$/, 'index.html');
				url = url + '#/login';
				if (window.location.href === url) {
					window.location.reload();
				} else {
					window.location.href = url;
				}
			} else if (errorCode === 600016) {
				Modal.warning({
					content: resData.errorDescription + '，无法使用，请联系客服',
					okText: '退出',
					onOk: () => {
						localStorage.clearAll();
						cache.clear();
						document.cookie = 'token' + '=;expires=' + (new Date(0)).toGMTString();
					}
				});
				let url = window.location.origin + window.location.pathname;
				url = url.replace(/[^/]+\.html$/, 'index.html');
				url = url + '#/login';
				window.location.href = url;
			} else {
				if (error) {
					error(resData);
				} else if (defaultError) {
					message.error(resData.errorDescription || '系统异常，请稍候再试', 1.5);
				}
			}

			return Promise.reject(response);
		}
	};

	return baseFetchApi({
		...resetConfig,
		service,
		data: commandObject,
		interceptors,
		headers
	});
}

export default fetchApi;
